function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { Fragment } from 'react';
import { getProfilePath, isProfileAdviser, getAuthorBadges } from '@finect/front-core/Profiles';
import { Strong } from '@finect/tabular-core/Strong';
import { Small } from '@finect/tabular-core/Small';
import { withTheme } from 'styled-components';
import { Icon } from '../Icon';
import { AdviserBadge } from '../AdviserBadge';
import { EntityCard } from '../EntityCard';
import { AuthorBlock, AuthorInfo, AuthorNameLink, CompanyLink } from './partials';
export var Author = function Author(_ref) {
  var theme = _ref.theme,
    action = _ref.action,
    author = _ref.author,
    main = _ref.main,
    _ref$loggedIn = _ref.loggedIn,
    loggedIn = _ref$loggedIn === void 0 ? false : _ref$loggedIn,
    _ref$withEntityCard = _ref.withEntityCard,
    withEntityCard = _ref$withEntityCard === void 0 ? false : _ref$withEntityCard,
    _ref$withMeta = _ref.withMeta,
    withMeta = _ref$withMeta === void 0 ? false : _ref$withMeta;
  var id = author.id,
    name = author.name,
    alias = author.alias,
    displayName = author.displayName,
    icon = author.icon,
    _author$organizations = author.organizations,
    organizations = _author$organizations === void 0 ? [] : _author$organizations,
    _author$features = author.features,
    features = _author$features === void 0 ? [] : _author$features;
  var subtype = author.subtype || author.type === 'company' ? 'company' : 'user';
  var withAuthorLink = features.includes('profile');
  var path = getProfilePath(theme, author);
  var link = path.pattern.match ? path.path : path.superPartnerURL;
  var company = organizations ? organizations.length > 0 ? organizations[0] : null : null;
  var isAdviser = isProfileAdviser(author);
  var isPro = ['company'].includes(subtype) || isAdviser;
  var companyHasBlog = company && company.features && company.features.blog && !company.private;
  var aditionalIcon = null;
  var badges = getAuthorBadges(author);
  var image = (icon || '').includes('image') ? icon : "/image/".concat(icon);
  var cardProps = {
    type: 'profile',
    entity: {
      id: id,
      name: name,
      subtype: subtype,
      alias: alias,
      displayName: displayName,
      icon: image,
      company: company,
      adviser: isAdviser,
      verified: isPro,
      aditionalIcon: aditionalIcon
    },
    loggedIn: loggedIn
  };
  var iconComponent = React.createElement(Icon, _extends({
    alt: name || alias,
    size: main ? 3 : 2,
    image: image,
    type: subtype,
    margin: "0 12px 0 0",
    aditionalIcon: aditionalIcon,
    verified: isPro
  }, withAuthorLink ? {
    url: link
  } : {}));
  var authorNameProps = withAuthorLink ? path.pattern.match ? {
    withLink: true,
    'data-fi-event': 'author-name',
    title: "Ver perfil de ".concat(displayName),
    href: path.url
  } : {
    withLink: true,
    'data-fi-event': 'author-name',
    title: "Ver perfil de ".concat(displayName),
    href: path.superPartnerURL
  } : {
    withLink: false,
    as: 'span'
  };
  var nameComponent = React.createElement("span", null, React.createElement(Strong, null, React.createElement(AuthorNameLink, authorNameProps, displayName), badges.map(function (badge, key) {
    return React.createElement(Fragment, {
      key: key
    }, ' ', React.createElement(AdviserBadge, {
      title: badge
    }));
  })), ' ', action);
  var numReviews = author.stats ? author.stats.reviews : 0;
  var metaComponent = React.createElement(Small, null, numReviews, " ", numReviews === 1 ? 'opinión' : 'opiniones');
  var getCompanyComponent = function getCompanyComponent() {
    if (company) {
      var companyPath = getProfilePath(theme, company);
      var props = {
        href: companyPath.url
      };
      if (!companyHasBlog) {
        return React.createElement(Small, null, company.displayName);
      }
      return React.createElement(Small, null, React.createElement(CompanyLink, _extends({
        title: company.displayName
      }, props), company.displayName));
    }
    return null;
  };
  var companyComponent = getCompanyComponent();
  return React.createElement(AuthorBlock, {
    badge: isAdviser
  }, withEntityCard ? React.createElement(EntityCard, _extends({}, cardProps, {
    arrowPosition: main ? 21 : null
  }), iconComponent) : iconComponent, React.createElement(AuthorInfo, null, withEntityCard ? React.createElement(EntityCard, cardProps, nameComponent) : nameComponent, ' ', React.createElement("div", null, withEntityCard && companyComponent && company ? React.createElement("div", null, companyHasBlog ? React.createElement(EntityCard, {
    type: "profile",
    entity: _objectSpread(_objectSpread({}, company), {}, {
      subtype: 'company',
      name: company.displayName
    })
  }, companyComponent) : React.createElement(Small, null, company.displayName)) : companyComponent, withMeta ? metaComponent : null)));
};
export default React.memo(withTheme(Author));